module.exports = __webpack_public_path__ + "img/info.56346a05.png";